var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',{staticClass:"mask",attrs:{"id":"email-download-box"}},[_c('div',{staticClass:"download-wrap",style:([_vm.isMobile ? {
      width: '100vmin',
      height: '95vmax',
      backgroundImage: _vm.imageUrl
    } : {
      width: '35%',
      height: '100%',
      backgroundImage: _vm.imageUrl
    }]),on:{"click":_vm.handleDownload}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }